import Logo from "../Logo";
import styles from './Navigation.module.css'
import cx from "classnames";
import React, {useEffect, useState} from "react";
import {useGlobalContext} from "../../contexts/GlobalContext";
import {ZrLink} from "../../ZrRouter";


type NavigationProps = {
    links: ZrLink[];
    title: string;
}

const Navigation: React.FC<NavigationProps> = ({title}: NavigationProps) => {
    const { useRoute: { route}} = useGlobalContext()
    const [checked, setChecked] = useState<boolean>(false)

    const {useFullscreen: {fullscreen, setFullscreen}} = useGlobalContext()

    useEffect(() => {
        setChecked(false)
    }, [route])

    return (
        <nav className={cx(styles["zr-nav"], fullscreen && styles["zr-sticky-nav"])}>
            <div className={cx(styles["zr-logo"])}>
                <Logo/>
                <span>{title}</span>
            </div>
            <div className={cx(styles["zr-desktop-nav"])}>
                <ul>
                    <li className={cx(styles["zr-fullscreen-icon"])}
                        onClick={() => {setFullscreen((prev: boolean) => !prev)}}
                    >&#x26F6;</li>
                </ul>
            </div>
            <label className={cx(styles["zr-burger-menu"])} htmlFor="zr-burger">
                <input
                    className={cx(styles["zr-hidden"])}
                    id="zr-burger"
                    type="checkbox"
                    onChange={() => setChecked(!checked)}
                />
                <span/>
            </label>
        </nav>
    )
}

export default Navigation;
